(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("clappr"), require("shaka"));
	else if(typeof define === 'function' && define.amd)
		define(["clappr", "shaka"], factory);
	else if(typeof exports === 'object')
		exports["ClapprShakaPlayback"] = factory(require("clappr"), require("shaka"));
	else
		root["ClapprShakaPlayback"] = factory(root["Clappr"], root["shaka"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition